import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/globe-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM3.05664 13C3.46977 16.7365 6.16895 19.7827 9.72559 20.709C8.19934 18.4146 7.27497 15.7628 7.05078 13H3.05664ZM16.9492 13C16.725 15.763 15.7999 18.4145 14.2734 20.709C17.8305 19.783 20.5302 16.7369 20.9434 13H16.9492ZM9.06152 13C9.31266 15.7118 10.3318 18.2939 12 20.4443C13.6682 18.2939 14.6873 15.7118 14.9385 13H9.06152ZM14.2734 3.29004C15.8001 5.58467 16.725 8.23673 16.9492 11H20.9434C20.5302 7.26306 17.8306 4.21593 14.2734 3.29004ZM12 3.55469C10.3315 5.70525 9.31268 8.28798 9.06152 11H14.9385C14.6873 8.28798 13.6685 5.70525 12 3.55469ZM9.72559 3.29004C6.16883 4.21622 3.46978 7.26338 3.05664 11H7.05078C7.27499 8.23691 8.19907 5.58457 9.72559 3.29004Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Globe01Icon };
